import { call, put, takeLatest } from 'redux-saga/effects';
import {
	RECEIVE_ZONE,
	ZONE_MANAGE_GET,
	ZONE_MANAGE_SUCCESS,
	ZONE_CREATE,
	ZONE_RENAME,
	ZONE_DELETE,
	ZONE_ASSIGN,
	ZONE_COPY,
} from '../constants/zone';
import { requestHandler } from './fetcher.saga';
import { ADD_NOTIFICATION, TAGS } from '../constants/notification';
import moment from 'moment';
import { I18n } from 'react-redux-i18n';

const ENTITY = 'zone';

function* notify(key, params, tag) {
	yield put({
		type: ADD_NOTIFICATION,
		notification: {
			tags: [tag || TAGS.SUCCESS],
			text: I18n.t(key, params),
			date: moment().format('DD/MM/YYYY HH:mm'),
			viewed: false,
			openable: false,
		},
	});
}

function* fetchManagement() {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		'GET',
		true,
		null,
		'/manage',
		{}
	);
	const payload = result && result.result ? result.result : {};
	yield put({
		type: ZONE_MANAGE_SUCCESS,
		zones: Array.isArray(payload.zones) ? payload.zones : [],
		children: Array.isArray(payload.children) ? payload.children : [],
	});
}

// Le sélecteur de zones lit state.entity.zone, alimenté par un autre appel :
// après une écriture, les deux doivent repartir du serveur.
function* refresh() {
	yield call(fetchManagement);
	const { result } = yield call(requestHandler, ENTITY, 'GET', true, null, '', {});
	if (result !== false) {
		// Même forme que dans fetchAll : le reducer lit response.result.
		yield put({ type: RECEIVE_ZONE, response: result });
	}
}

function* createZone(action) {
	const body = { name: action.name };
	if (action.by) body.by = action.by;
	if (action.usage) body.usage = action.usage;

	const { result } = yield call(
		requestHandler,
		ENTITY,
		'POST',
		true,
		body,
		'',
		{}
	);

	if (result === false) {
		yield call(notify, 'zoneManager.createFail', {}, TAGS.ERROR);
		yield call(fetchManagement);
		return;
	}

	yield call(refresh);

	// La première zone a deux effets que l'utilisateur n'a demandés
	// qu'indirectement : tout le parc y est entré, et les règles de
	// synchronisation du siège ont changé. Les deux se disent.
	const payload = result.result || {};
	if (payload.firstZone) {
		yield call(notify, 'zoneManager.firstCreated', {
			name: action.name,
			assigned: payload.assigned || 0,
		});
	} else {
		yield call(notify, 'zoneManager.created', { name: action.name });
	}
}

function* renameZone(action) {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		'PATCH',
		true,
		{ id: action.id, name: action.name },
		'',
		{}
	);

	if (result === false) {
		yield call(notify, 'zoneManager.renameFail', {}, TAGS.ERROR);
		yield call(fetchManagement);
		return;
	}
	yield call(refresh);
}

function* deleteZone(action) {
	const body = { id: action.id };
	if (action.id_zone_target) body.id_zone_target = action.id_zone_target;

	const { result } = yield call(
		requestHandler,
		ENTITY,
		'DELETE',
		true,
		body,
		'',
		{}
	);

	if (result === false) {
		yield call(notify, 'zoneManager.deleteFail', {}, TAGS.ERROR);
		yield call(fetchManagement);
		return;
	}

	// La zone supprimée pouvait être celle de la session : l'en-tête x-zone
	// serait alors écarté silencieusement à chaque appel, faisant basculer en
	// mode siège global sans le dire. On repart proprement.
	const selected = window.sessionStorage.getItem('id_zone');
	if (selected && String(selected) === String(action.id)) {
		window.sessionStorage.removeItem('id_zone');
		window.location.reload();
		return;
	}

	yield call(refresh);
}

function* assignZones(action) {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		'POST',
		true,
		{ assignments: action.assignments },
		'/assign',
		{}
	);

	if (result === false) {
		yield call(notify, 'zoneManager.assignFail', {}, TAGS.ERROR);
		yield call(fetchManagement);
		return;
	}

	yield call(refresh);
	yield call(notify, 'zoneManager.assigned', {});
}

function* copyZone(action) {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		'POST',
		true,
		{ id: action.id, from: action.from },
		'/copy',
		{}
	);

	if (result === false) {
		yield call(notify, 'zoneManager.copyFail', {}, TAGS.ERROR);
		yield call(fetchManagement);
		return;
	}

	yield call(refresh);
	const payload = result.result || {};
	yield call(notify, 'zoneManager.copied', { count: payload.copied || 0 });
}

export function* watchCopyZone() {
	yield takeLatest(ZONE_COPY, copyZone);
}

export function* watchGetZoneManagement() {
	yield takeLatest(ZONE_MANAGE_GET, fetchManagement);
}
export function* watchCreateZone() {
	yield takeLatest(ZONE_CREATE, createZone);
}
export function* watchRenameZone() {
	yield takeLatest(ZONE_RENAME, renameZone);
}
export function* watchDeleteZone() {
	yield takeLatest(ZONE_DELETE, deleteZone);
}
export function* watchAssignZones() {
	yield takeLatest(ZONE_ASSIGN, assignZones);
}
